var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "807ba5bd03"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.746094 108.886719 L 258.496094 108.886719 L 258.496094 266.386719 L 116.746094 266.386719 Z M 116.746094 108.886719 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#807ba5bd03)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 223.292969 188.109375 L 214.945312 179.761719 L 176.519531 218.191406 L 159.824219 201.496094 L 151.476562 209.84375 L 176.519531 234.886719 Z M 242.742188 124.636719 L 234.871094 124.636719 L 234.871094 108.886719 L 219.121094 108.886719 L 219.121094 124.636719 L 156.125 124.636719 L 156.125 108.886719 L 140.375 108.886719 L 140.375 124.636719 L 132.5 124.636719 C 123.796875 124.636719 116.828125 131.683594 116.828125 140.386719 L 116.75 250.636719 C 116.75 259.335938 123.796875 266.386719 132.5 266.386719 L 242.742188 266.386719 C 251.445312 266.386719 258.492188 259.335938 258.492188 250.636719 L 258.492188 140.386719 C 258.492188 131.683594 251.445312 124.636719 242.742188 124.636719 Z M 242.742188 250.636719 L 132.5 250.636719 L 132.5 164.011719 L 242.742188 164.011719 Z M 242.742188 250.636719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarFilter);
export default __webpack_public_path__ + "static/media/calendar-filter.dffc3a479a00348f0eed4aff0a332232.svg";
export { ForwardRef as ReactComponent };